import React__default, { createContext, useContext, useState, useCallback } from 'react';
import Dialog from './Dialog.js';
import Typography from '../Atoms/Typography.js';
import Button from '../Atoms/Button.js';
import { useTranslation } from 'react-i18next';
import Portal from '../Atoms/Portal.js';

var AlertContext = createContext(null);
function AlertProvider(_a) {
    var children = _a.children;
    var t = useTranslation().t;
    var _b = React__default.useState(false), _isOpen = _b[0], setIsOpen = _b[1];
    var _c = useState(''), title = _c[0], setTitle = _c[1];
    var _d = useState(''), content = _d[0], setContent = _d[1];
    var _e = useState(function () { }), _onCancel = _e[0], setOnCancel = _e[1];
    var _f = useState(''), _type = _f[0], setType = _f[1];
    var setData = function (confirmProps) {
        setTitle(confirmProps.title);
        setContent(confirmProps.content);
        setOnCancel(confirmProps.onClose);
        setType(confirmProps.type);
    };
    var _preprocessClose = useCallback(function () {
        setIsOpen(false);
        _onCancel && _onCancel();
    }, [_onCancel]);
    var showDialog = function () {
        setIsOpen(true);
    };
    return (React__default.createElement(AlertContext.Provider, { value: { setData: setData, showDialog: showDialog } },
        children,
        React__default.createElement(Portal, null,
            React__default.createElement(Dialog, { classes: "alert_dialog dialog__type__".concat(_type), isOpen: _isOpen, onClose: _preprocessClose, title: title, uniqueKey: "alert-box", removeCloseIcon: true, footer: React__default.createElement("div", { className: "alert__footer" },
                    React__default.createElement(Button, { variant: "solid", size: "md", onClick: _preprocessClose }, t('common.ok'))) },
                React__default.createElement(Typography, { variant: "bodyTextOne" }, content)))));
}
function useAlert() {
    var alertCtx = useContext(AlertContext);
    return function (_a) {
        var title = _a.title, content = _a.content, type = _a.type, onClose = _a.onClose;
        alertCtx.setData({ title: title, content: content, type: type, onClose: onClose });
        alertCtx.showDialog();
    };
}

export { AlertContext, AlertProvider, useAlert as default };
//# sourceMappingURL=Alert.js.map
